module.exports = '<svg width="43" height="32" viewBox="0 0 43 32"><path d="M40.336 32H2.325C.213 32-.598 29.328.469 27.851L19.376 1.307c1.077-1.472 2.832-1.845 3.909-.368l18.907 27.099c1.077 1.472.251 3.963-1.856 3.963z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-1.js
// module id = 1467
// module chunks = 14